import { DocumentServicesObject, CompRef } from '@wix/document-services-types';
import { getBuilderAppData } from './getBuilderAppData';
import { isBuilderComponentModelSupported } from '../../../bootstrap/platformApiEnhancer/builderComponentModel';

const getBuilderCompAppData = (
  componentRef: CompRef,
  documentServicesAPI: DocumentServicesObject,
) => {
  if (!isBuilderComponentModelSupported()) {
    return null;
  }

  const { isBuilder, builderCompData } = getBuilderAppData(
    componentRef,
    documentServicesAPI,
  );

  if (!isBuilder) {
    return null;
  }

  if (!builderCompData?.appDefinitionId) {
    throw new Error('Builder component data is not valid');
  }

  return builderCompData;
};

export function getAppDataByCompRef(
  documentServicesAPI: DocumentServicesObject,
  widgetCompRef: CompRef,
): { widgetId: string; appDefinitionId: string } {
  const builderCompData = getBuilderCompAppData(
    widgetCompRef,
    documentServicesAPI,
  );

  if (builderCompData) {
    return {
      widgetId: builderCompData?.componentId,
      appDefinitionId: builderCompData?.appDefinitionId,
    };
  }

  const { appDefinitionId, widgetId } =
    documentServicesAPI.components.data.get(widgetCompRef);
  if (!widgetId || !appDefinitionId) {
    throw new Error('component data is not valid');
  }
  return {
    widgetId,
    appDefinitionId,
  };
}
